import React from "react";
import AuthLayout from "../layouts/auth";
import PaymentMethodsForm from "../components/payment-method-form";

function AddPaymentMethod() {
  return (
    <AuthLayout>
      <PaymentMethodsForm />
    </AuthLayout>
  );
}

export default AddPaymentMethod;
